
import styled from "styled-components"

function DbExamesCompleto() { 
  return(database_exames);
}

function DbExames(indice) { 
  return(database_exames[indice]);
}

export {DbExamesCompleto, DbExames};

const database_exames = [
  {
    "Hemograma": 1,
    "Idade": 1,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.82,
    "Hemoglobina": 10.2,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 83.77,
    "Hem. Corp. Média": 26.7,
    "C. H. Corp. Média": 31.88,
    "Leucócitos": 7800,
    "Basófilos": 0,
    "Eosinófilos": 780,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 78,
    "Segmentados": 2496,
    "Linfócitos": 4056,
    "Monócitos": 390
  },
  {
    "Hemograma": 2,
    "Idade": 50,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.82,
    "Hemoglobina": 14.2,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 89.21,
    "Hem. Corp. Média": 29.46,
    "C. H. Corp. Média": 33.02,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 204,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 68,
    "Segmentados": 3468,
    "Linfócitos": 2652,
    "Monócitos": 340
  },
  {
    "Hemograma": 3,
    "Idade": 24,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.02,
    "Hemoglobina": 11,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 84.58,
    "Hem. Corp. Média": 27.36,
    "C. H. Corp. Média": 32.35,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 180,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3360,
    "Linfócitos": 2160,
    "Monócitos": 300
  },
  {
    "Hemograma": 4,
    "Idade": 24,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.53,
    "Hemoglobina": 9.9,
    "Hematócrito": 0.3,
    "Vol. Corp. Médio": 84.99,
    "Hem. Corp. Média": 28.05,
    "C. H. Corp. Média": 33,
    "Leucócitos": 6400,
    "Basófilos": 0,
    "Eosinófilos": 64,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 64,
    "Segmentados": 4032,
    "Linfócitos": 1856,
    "Monócitos": 384
  },
  {
    "Hemograma": 5,
    "Idade": 65,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.92,
    "Hemoglobina": 12.5,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 96.94,
    "Hem. Corp. Média": 31.89,
    "C. H. Corp. Média": 32.89,
    "Leucócitos": 7700,
    "Basófilos": 0,
    "Eosinófilos": 154,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4081,
    "Linfócitos": 3003,
    "Monócitos": 462
  },
  {
    "Hemograma": 6,
    "Idade": 18,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.87,
    "Hemoglobina": 12.1,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 93.02,
    "Hem. Corp. Média": 31.27,
    "C. H. Corp. Média": 33.61,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 272,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3468,
    "Linfócitos": 2720,
    "Monócitos": 340
  },
  {
    "Hemograma": 7,
    "Idade": 59,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.85,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 96.1,
    "Hem. Corp. Média": 31.95,
    "C. H. Corp. Média": 33.24,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 360,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 60,
    "Segmentados": 3000,
    "Linfócitos": 2340,
    "Monócitos": 240
  },
  {
    "Hemograma": 8,
    "Idade": 1,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.43,
    "Hemoglobina": 6.6,
    "Hematócrito": 0.24,
    "Vol. Corp. Médio": 54.18,
    "Hem. Corp. Média": 14.9,
    "C. H. Corp. Média": 27.5,
    "Leucócitos": 9600,
    "Basófilos": 0,
    "Eosinófilos": 96,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4608,
    "Linfócitos": 3744,
    "Monócitos": 1152
  },
  {
    "Hemograma": 9,
    "Idade": 54,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.17,
    "Hemoglobina": 14.1,
    "Hematócrito": 0.42,
    "Vol. Corp. Médio": 100.72,
    "Hem. Corp. Média": 33.81,
    "C. H. Corp. Média": 33.57,
    "Leucócitos": 5200,
    "Basófilos": 0,
    "Eosinófilos": 260,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 52,
    "Segmentados": 2340,
    "Linfócitos": 2444,
    "Monócitos": 104
  },
  {
    "Hemograma": 10,
    "Idade": 54,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.4,
    "Hemoglobina": 15.1,
    "Hematócrito": 0.45,
    "Vol. Corp. Médio": 102.27,
    "Hem. Corp. Média": 34.32,
    "C. H. Corp. Média": 33.56,
    "Leucócitos": 6500,
    "Basófilos": 0,
    "Eosinófilos": 650,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 260,
    "Segmentados": 2600,
    "Linfócitos": 2145,
    "Monócitos": 520
  },
  {
    "Hemograma": 11,
    "Idade": 55,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.14,
    "Hemoglobina": 12.6,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 91.79,
    "Hem. Corp. Média": 30.43,
    "C. H. Corp. Média": 33.16,
    "Leucócitos": 4500,
    "Basófilos": 0,
    "Eosinófilos": 135,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 45,
    "Segmentados": 1935,
    "Linfócitos": 2205,
    "Monócitos": 180
  },
  {
    "Hemograma": 12,
    "Idade": 60,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.48,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 106.32,
    "Hem. Corp. Média": 35.34,
    "C. H. Corp. Média": 33.24,
    "Leucócitos": 3100,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 31,
    "Segmentados": 1178,
    "Linfócitos": 1674,
    "Monócitos": 217
  },
  {
    "Hemograma": 13,
    "Idade": 67,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.08,
    "Hemoglobina": 12.7,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 93.14,
    "Hem. Corp. Média": 31.13,
    "C. H. Corp. Média": 33.42,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 180,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 60,
    "Segmentados": 2520,
    "Linfócitos": 3000,
    "Monócitos": 240
  },
  {
    "Hemograma": 14,
    "Idade": 71,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.9,
    "Hemoglobina": 15.4,
    "Hematócrito": 0.47,
    "Vol. Corp. Médio": 95.32,
    "Hem. Corp. Média": 31.43,
    "C. H. Corp. Média": 32.77,
    "Leucócitos": 5600,
    "Basófilos": 0,
    "Eosinófilos": 112,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3192,
    "Linfócitos": 2072,
    "Monócitos": 224
  },
  {
    "Hemograma": 15,
    "Idade": 12,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.11,
    "Hemoglobina": 12,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 90.02,
    "Hem. Corp. Média": 29.2,
    "C. H. Corp. Média": 32.43,
    "Leucócitos": 5600,
    "Basófilos": 0,
    "Eosinófilos": 448,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 56,
    "Segmentados": 2744,
    "Linfócitos": 2296,
    "Monócitos": 56
  },
  {
    "Hemograma": 16,
    "Idade": 53,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.17,
    "Hemoglobina": 13.2,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 95.92,
    "Hem. Corp. Média": 31.65,
    "C. H. Corp. Média": 33,
    "Leucócitos": 1800,
    "Basófilos": 0,
    "Eosinófilos": 36,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 18,
    "Segmentados": 882,
    "Linfócitos": 810,
    "Monócitos": 54
  },
  {
    "Hemograma": 17,
    "Idade": 32,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.08,
    "Hemoglobina": 9.7,
    "Hematócrito": 0.29,
    "Vol. Corp. Médio": 94.16,
    "Hem. Corp. Média": 31.49,
    "C. H. Corp. Média": 33.45,
    "Leucócitos": 3000,
    "Basófilos": 0,
    "Eosinófilos": 60,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 30,
    "Segmentados": 1620,
    "Linfócitos": 1140,
    "Monócitos": 150
  },
  {
    "Hemograma": 18,
    "Idade": 67,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.24,
    "Hemoglobina": 13.5,
    "Hematócrito": 0.41,
    "Vol. Corp. Médio": 96.7,
    "Hem. Corp. Média": 31.84,
    "C. H. Corp. Média": 32.93,
    "Leucócitos": 6400,
    "Basófilos": 0,
    "Eosinófilos": 128,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 64,
    "Segmentados": 3136,
    "Linfócitos": 2880,
    "Monócitos": 192
  },
  {
    "Hemograma": 19,
    "Idade": 74,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.32,
    "Hemoglobina": 14.5,
    "Hematócrito": 0.44,
    "Vol. Corp. Médio": 101.85,
    "Hem. Corp. Média": 33.56,
    "C. H. Corp. Média": 32.95,
    "Leucócitos": 5300,
    "Basófilos": 0,
    "Eosinófilos": 106,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 106,
    "Segmentados": 3286,
    "Linfócitos": 1431,
    "Monócitos": 371
  },
  {
    "Hemograma": 20,
    "Idade": 10,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.23,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 82.74,
    "Hem. Corp. Média": 29.08,
    "C. H. Corp. Média": 35.14,
    "Leucócitos": 6400,
    "Basófilos": 0,
    "Eosinófilos": 256,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 128,
    "Segmentados": 3712,
    "Linfócitos": 2048,
    "Monócitos": 256
  },
  {
    "Hemograma": 21,
    "Idade": 75,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.47,
    "Hemoglobina": 10.9,
    "Hematócrito": 0.3,
    "Vol. Corp. Médio": 86.46,
    "Hem. Corp. Média": 31.41,
    "C. H. Corp. Média": 36.33,
    "Leucócitos": 10600,
    "Basófilos": 0,
    "Eosinófilos": 106,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 9540,
    "Linfócitos": 954,
    "Monócitos": 0
  },
  {
    "Hemograma": 22,
    "Idade": 74,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.69,
    "Hemoglobina": 10.7,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 92.14,
    "Hem. Corp. Média": 29,
    "C. H. Corp. Média": 31.47,
    "Leucócitos": 16100,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 805,
    "Segmentados": 11431,
    "Linfócitos": 3864,
    "Monócitos": 0
  },
  {
    "Hemograma": 23,
    "Idade": 63,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.69,
    "Hemoglobina": 15,
    "Hematócrito": 0.45,
    "Vol. Corp. Médio": 95.95,
    "Hem. Corp. Média": 31.98,
    "C. H. Corp. Média": 33.33,
    "Leucócitos": 13800,
    "Basófilos": 0,
    "Eosinófilos": 276,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 10074,
    "Linfócitos": 3312,
    "Monócitos": 138
  },
  {
    "Hemograma": 24,
    "Idade": 57,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.58,
    "Hemoglobina": 11.1,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 100.56,
    "Hem. Corp. Média": 31.01,
    "C. H. Corp. Média": 30.83,
    "Leucócitos": 4000,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 1880,
    "Linfócitos": 2000,
    "Monócitos": 120
  },
  {
    "Hemograma": 25,
    "Idade": 84,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.12,
    "Hemoglobina": 9.5,
    "Hematócrito": 0.28,
    "Vol. Corp. Médio": 89.74,
    "Hem. Corp. Média": 30.45,
    "C. H. Corp. Média": 33.93,
    "Leucócitos": 5800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 174,
    "Segmentados": 4582,
    "Linfócitos": 754,
    "Monócitos": 290
  },
  {
    "Hemograma": 26,
    "Idade": 73,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.15,
    "Hemoglobina": 11.9,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 84.34,
    "Hem. Corp. Média": 28.67,
    "C. H. Corp. Média": 34,
    "Leucócitos": 22800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 2052,
    "Segmentados": 18924,
    "Linfócitos": 1140,
    "Monócitos": 684
  },
  {
    "Hemograma": 27,
    "Idade": 28,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.89,
    "Hemoglobina": 14.1,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 87.93,
    "Hem. Corp. Média": 28.83,
    "C. H. Corp. Média": 32.79,
    "Leucócitos": 12300,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 123,
    "Segmentados": 9840,
    "Linfócitos": 1845,
    "Monócitos": 492
  },
  {
    "Hemograma": 28,
    "Idade": 55,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 2.82,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 113.48,
    "Hem. Corp. Média": 38.3,
    "C. H. Corp. Média": 33.75,
    "Leucócitos": 16400,
    "Basófilos": 0,
    "Eosinófilos": 164,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 492,
    "Segmentados": 13448,
    "Linfócitos": 1804,
    "Monócitos": 492
  },
  {
    "Hemograma": 29,
    "Idade": 70,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.11,
    "Hemoglobina": 13,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 97.32,
    "Hem. Corp. Média": 31.63,
    "C. H. Corp. Média": 32.5,
    "Leucócitos": 5500,
    "Basófilos": 0,
    "Eosinófilos": 110,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 2915,
    "Linfócitos": 2200,
    "Monócitos": 275
  },
  {
    "Hemograma": 30,
    "Idade": 57,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.08,
    "Hemoglobina": 13.8,
    "Hematócrito": 0.41,
    "Vol. Corp. Médio": 100.49,
    "Hem. Corp. Média": 33.82,
    "C. H. Corp. Média": 33.66,
    "Leucócitos": 6100,
    "Basófilos": 0,
    "Eosinófilos": 122,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3538,
    "Linfócitos": 2318,
    "Monócitos": 122
  },
  {
    "Hemograma": 31,
    "Idade": 57,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.67,
    "Hemoglobina": 14,
    "Hematócrito": 0.42,
    "Vol. Corp. Médio": 89.94,
    "Hem. Corp. Média": 29.98,
    "C. H. Corp. Média": 33.33,
    "Leucócitos": 4500,
    "Basófilos": 0,
    "Eosinófilos": 45,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 1980,
    "Linfócitos": 2295,
    "Monócitos": 180
  },
  {
    "Hemograma": 32,
    "Idade": 61,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.29,
    "Hemoglobina": 13.3,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 90.91,
    "Hem. Corp. Média": 31,
    "C. H. Corp. Média": 34.1,
    "Leucócitos": 6500,
    "Basófilos": 0,
    "Eosinófilos": 65,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4160,
    "Linfócitos": 2015,
    "Monócitos": 260
  },
  {
    "Hemograma": 33,
    "Idade": 47,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.16,
    "Hemoglobina": 13,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 91.35,
    "Hem. Corp. Média": 31.25,
    "C. H. Corp. Média": 34.21,
    "Leucócitos": 6600,
    "Basófilos": 0,
    "Eosinófilos": 132,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3168,
    "Linfócitos": 3036,
    "Monócitos": 264
  },
  {
    "Hemograma": 34,
    "Idade": 18,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.41,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 90.91,
    "Hem. Corp. Média": 31.67,
    "C. H. Corp. Média": 34.84,
    "Leucócitos": 5700,
    "Basófilos": 0,
    "Eosinófilos": 57,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 57,
    "Segmentados": 3591,
    "Linfócitos": 1767,
    "Monócitos": 228
  },
  {
    "Hemograma": 35,
    "Idade": 68,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.37,
    "Hemoglobina": 13.4,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 91.53,
    "Hem. Corp. Média": 30.66,
    "C. H. Corp. Média": 33.5,
    "Leucócitos": 15400,
    "Basófilos": 0,
    "Eosinófilos": 154,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 1848,
    "Segmentados": 10472,
    "Linfócitos": 2464,
    "Monócitos": 462
  },
  {
    "Hemograma": 36,
    "Idade": 64,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.65,
    "Hemoglobina": 11.8,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 95.89,
    "Hem. Corp. Média": 32.33,
    "C. H. Corp. Média": 33.71,
    "Leucócitos": 5100,
    "Basófilos": 0,
    "Eosinófilos": 51,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 2907,
    "Linfócitos": 1989,
    "Monócitos": 153
  },
  {
    "Hemograma": 37,
    "Idade": 27,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.95,
    "Hemoglobina": 12.5,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 93.67,
    "Hem. Corp. Média": 31.65,
    "C. H. Corp. Média": 33.78,
    "Leucócitos": 11600,
    "Basófilos": 0,
    "Eosinófilos": 116,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 116,
    "Segmentados": 7888,
    "Linfócitos": 2900,
    "Monócitos": 580
  },
  {
    "Hemograma": 38,
    "Idade": 62,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.31,
    "Hemoglobina": 13.1,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 92.81,
    "Hem. Corp. Média": 30.39,
    "C. H. Corp. Média": 32.75,
    "Leucócitos": 4700,
    "Basófilos": 0,
    "Eosinófilos": 47,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 47,
    "Segmentados": 2491,
    "Linfócitos": 1974,
    "Monócitos": 141
  },
  {
    "Hemograma": 39,
    "Idade": 35,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.43,
    "Hemoglobina": 14.6,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 97.07,
    "Hem. Corp. Média": 32.96,
    "C. H. Corp. Média": 33.95,
    "Leucócitos": 5200,
    "Basófilos": 0,
    "Eosinófilos": 104,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3276,
    "Linfócitos": 1664,
    "Monócitos": 156
  },
  {
    "Hemograma": 40,
    "Idade": 51,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.78,
    "Hemoglobina": 15,
    "Hematócrito": 0.46,
    "Vol. Corp. Médio": 96.23,
    "Hem. Corp. Média": 31.38,
    "C. H. Corp. Média": 32.61,
    "Leucócitos": 11100,
    "Basófilos": 0,
    "Eosinófilos": 111,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 7770,
    "Linfócitos": 2775,
    "Monócitos": 444
  },
  {
    "Hemograma": 41,
    "Idade": 34,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.08,
    "Hemoglobina": 12,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 88.24,
    "Hem. Corp. Média": 29.41,
    "C. H. Corp. Média": 33.33,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 60,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 60,
    "Segmentados": 3780,
    "Linfócitos": 1800,
    "Monócitos": 300
  },
  {
    "Hemograma": 42,
    "Idade": 61,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.39,
    "Hemoglobina": 9.6,
    "Hematócrito": 0.29,
    "Vol. Corp. Médio": 85.55,
    "Hem. Corp. Média": 28.32,
    "C. H. Corp. Média": 33.1,
    "Leucócitos": 11500,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 230,
    "Segmentados": 10120,
    "Linfócitos": 920,
    "Monócitos": 230
  },
  {
    "Hemograma": 43,
    "Idade": 81,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.5,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 94.29,
    "Hem. Corp. Média": 32.29,
    "C. H. Corp. Média": 34.24,
    "Leucócitos": 13000,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 1040,
    "Segmentados": 10140,
    "Linfócitos": 1430,
    "Monócitos": 390
  },
  {
    "Hemograma": 44,
    "Idade": 27,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.87,
    "Hemoglobina": 12,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 80.1,
    "Hem. Corp. Média": 31.01,
    "C. H. Corp. Média": 38.71,
    "Leucócitos": 12000,
    "Basófilos": 0,
    "Eosinófilos": 120,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 240,
    "Segmentados": 7200,
    "Linfócitos": 3960,
    "Monócitos": 480
  },
  {
    "Hemograma": 45,
    "Idade": 16,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.28,
    "Hemoglobina": 13.2,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 91.12,
    "Hem. Corp. Média": 30.84,
    "C. H. Corp. Média": 33.85,
    "Leucócitos": 13600,
    "Basófilos": 0,
    "Eosinófilos": 136,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 2040,
    "Segmentados": 8976,
    "Linfócitos": 2312,
    "Monócitos": 136
  },
  {
    "Hemograma": 46,
    "Idade": 59,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 2.74,
    "Hemoglobina": 8.1,
    "Hematócrito": 0.26,
    "Vol. Corp. Médio": 94.89,
    "Hem. Corp. Média": 29.56,
    "C. H. Corp. Média": 31.15,
    "Leucócitos": 6900,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 5520,
    "Linfócitos": 1173,
    "Monócitos": 207
  },
  {
    "Hemograma": 47,
    "Idade": 69,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.7,
    "Hemoglobina": 13.6,
    "Hematócrito": 0.44,
    "Vol. Corp. Médio": 93.62,
    "Hem. Corp. Média": 28.94,
    "C. H. Corp. Média": 30.91,
    "Leucócitos": 8500,
    "Basófilos": 0,
    "Eosinófilos": 170,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4335,
    "Linfócitos": 3825,
    "Monócitos": 170
  },
  {
    "Hemograma": 48,
    "Idade": 1,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 5.12,
    "Hemoglobina": 12.7,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 74.22,
    "Hem. Corp. Média": 24.8,
    "C. H. Corp. Média": 33.42,
    "Leucócitos": 17900,
    "Basófilos": 0,
    "Eosinófilos": 1432,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 8592,
    "Linfócitos": 8592,
    "Monócitos": 358
  },
  {
    "Hemograma": 49,
    "Idade": 54,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.98,
    "Hemoglobina": 12,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 87.94,
    "Hem. Corp. Média": 30.15,
    "C. H. Corp. Média": 34.29,
    "Leucócitos": 11400,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 114,
    "Segmentados": 9234,
    "Linfócitos": 1824,
    "Monócitos": 228
  },
  {
    "Hemograma": 50,
    "Idade": 88,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.35,
    "Hemoglobina": 10.5,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 98.51,
    "Hem. Corp. Média": 31.34,
    "C. H. Corp. Média": 31.82,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 60,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3720,
    "Linfócitos": 2160,
    "Monócitos": 60
  },
  {
    "Hemograma": 51,
    "Idade": 74,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.35,
    "Hemoglobina": 9.8,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 92.54,
    "Hem. Corp. Média": 29.25,
    "C. H. Corp. Média": 31.61,
    "Leucócitos": 11300,
    "Basófilos": 0,
    "Eosinófilos": 226,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 339,
    "Segmentados": 8249,
    "Linfócitos": 2260,
    "Monócitos": 226
  },
  {
    "Hemograma": 52,
    "Idade": 52,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.91,
    "Hemoglobina": 13.9,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 109.97,
    "Hem. Corp. Média": 35.55,
    "C. H. Corp. Média": 32.33,
    "Leucócitos": 9400,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 94,
    "Segmentados": 8460,
    "Linfócitos": 752,
    "Monócitos": 94
  },
  {
    "Hemograma": 53,
    "Idade": 61,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.74,
    "Hemoglobina": 13.2,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 104.28,
    "Hem. Corp. Média": 35.29,
    "C. H. Corp. Média": 33.85,
    "Leucócitos": 10200,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 7752,
    "Linfócitos": 2346,
    "Monócitos": 102
  },
  {
    "Hemograma": 54,
    "Idade": 62,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 5.23,
    "Hemoglobina": 13.3,
    "Hematócrito": 0.41,
    "Vol. Corp. Médio": 78.39,
    "Hem. Corp. Média": 25.43,
    "C. H. Corp. Média": 32.44,
    "Leucócitos": 6300,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 63,
    "Segmentados": 3717,
    "Linfócitos": 2457,
    "Monócitos": 63
  },
  {
    "Hemograma": 55,
    "Idade": 33,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.16,
    "Hemoglobina": 12.7,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 91.35,
    "Hem. Corp. Média": 30.53,
    "C. H. Corp. Média": 33.42,
    "Leucócitos": 9000,
    "Basófilos": 0,
    "Eosinófilos": 630,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4500,
    "Linfócitos": 3600,
    "Monócitos": 270
  },
  {
    "Hemograma": 56,
    "Idade": 35,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.82,
    "Hemoglobina": 11.4,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 91.62,
    "Hem. Corp. Média": 29.84,
    "C. H. Corp. Média": 32.57,
    "Leucócitos": 7400,
    "Basófilos": 0,
    "Eosinófilos": 222,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 74,
    "Segmentados": 4070,
    "Linfócitos": 2590,
    "Monócitos": 444
  },
  {
    "Hemograma": 57,
    "Idade": 75,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.1,
    "Hemoglobina": 13,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 95.12,
    "Hem. Corp. Média": 31.71,
    "C. H. Corp. Média": 33.33,
    "Leucócitos": 6200,
    "Basófilos": 0,
    "Eosinófilos": 124,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3472,
    "Linfócitos": 2480,
    "Monócitos": 124
  },
  {
    "Hemograma": 58,
    "Idade": 31,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.14,
    "Hemoglobina": 12.9,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 91.79,
    "Hem. Corp. Média": 31.16,
    "C. H. Corp. Média": 33.95,
    "Leucócitos": 6300,
    "Basófilos": 0,
    "Eosinófilos": 189,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3150,
    "Linfócitos": 2898,
    "Monócitos": 63
  },
  {
    "Hemograma": 59,
    "Idade": 63,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.81,
    "Hemoglobina": 11.8,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 91.86,
    "Hem. Corp. Média": 30.97,
    "C. H. Corp. Média": 33.71,
    "Leucócitos": 6600,
    "Basófilos": 0,
    "Eosinófilos": 330,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 66,
    "Segmentados": 3036,
    "Linfócitos": 2970,
    "Monócitos": 198
  },
  {
    "Hemograma": 60,
    "Idade": 62,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.41,
    "Hemoglobina": 13.1,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 90.7,
    "Hem. Corp. Média": 29.71,
    "C. H. Corp. Média": 33.75,
    "Leucócitos": 3900,
    "Basófilos": 0,
    "Eosinófilos": 624,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 39,
    "Segmentados": 1131,
    "Linfócitos": 1872,
    "Monócitos": 234
  },
  {
    "Hemograma": 61,
    "Idade": 82,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.03,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 91.81,
    "Hem. Corp. Média": 30.52,
    "C. H. Corp. Média": 33.24,
    "Leucócitos": 8600,
    "Basófilos": 0,
    "Eosinófilos": 258,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 172,
    "Segmentados": 4472,
    "Linfócitos": 3440,
    "Monócitos": 258
  },
  {
    "Hemograma": 62,
    "Idade": 58,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 2.13,
    "Hemoglobina": 6.5,
    "Hematócrito": 0.2,
    "Vol. Corp. Médio": 93.9,
    "Hem. Corp. Média": 30.52,
    "C. H. Corp. Média": 32.5,
    "Leucócitos": 15800,
    "Basófilos": 0,
    "Eosinófilos": 158,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 790,
    "Segmentados": 12640,
    "Linfócitos": 1738,
    "Monócitos": 474
  },
  {
    "Hemograma": 63,
    "Idade": 67,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.94,
    "Hemoglobina": 11.8,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 91.37,
    "Hem. Corp. Média": 29.95,
    "C. H. Corp. Média": 32.78,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 136,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 136,
    "Segmentados": 3672,
    "Linfócitos": 2720,
    "Monócitos": 136
  },
  {
    "Hemograma": 64,
    "Idade": 99,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.25,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 84.71,
    "Hem. Corp. Média": 26.59,
    "C. H. Corp. Média": 31.39,
    "Leucócitos": 11000,
    "Basófilos": 0,
    "Eosinófilos": 110,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 220,
    "Segmentados": 9240,
    "Linfócitos": 990,
    "Monócitos": 440
  },
  {
    "Hemograma": 65,
    "Idade": 36,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.53,
    "Hemoglobina": 9.8,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 87.82,
    "Hem. Corp. Média": 27.76,
    "C. H. Corp. Média": 31.61,
    "Leucócitos": 7700,
    "Basófilos": 0,
    "Eosinófilos": 154,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 154,
    "Segmentados": 3850,
    "Linfócitos": 3157,
    "Monócitos": 385
  },
  {
    "Hemograma": 66,
    "Idade": 62,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.18,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 93.3,
    "Hem. Corp. Média": 29.43,
    "C. H. Corp. Média": 31.54,
    "Leucócitos": 6500,
    "Basófilos": 0,
    "Eosinófilos": 130,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 195,
    "Segmentados": 3575,
    "Linfócitos": 2340,
    "Monócitos": 260
  },
  {
    "Hemograma": 67,
    "Idade": 87,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.22,
    "Hemoglobina": 10.6,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 102.48,
    "Hem. Corp. Média": 32.92,
    "C. H. Corp. Média": 32.12,
    "Leucócitos": 7400,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 370,
    "Segmentados": 5846,
    "Linfócitos": 888,
    "Monócitos": 296
  },
  {
    "Hemograma": 68,
    "Idade": 85,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 2.07,
    "Hemoglobina": 5.8,
    "Hematócrito": 0.18,
    "Vol. Corp. Médio": 86.96,
    "Hem. Corp. Média": 28.02,
    "C. H. Corp. Média": 32.22,
    "Leucócitos": 7200,
    "Basófilos": 0,
    "Eosinófilos": 360,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 360,
    "Segmentados": 5040,
    "Linfócitos": 1296,
    "Monócitos": 144
  },
  {
    "Hemograma": 69,
    "Idade": 42,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 2.88,
    "Hemoglobina": 10.2,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 111.11,
    "Hem. Corp. Média": 35.42,
    "C. H. Corp. Média": 31.88,
    "Leucócitos": 10000,
    "Basófilos": 0,
    "Eosinófilos": 700,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 300,
    "Segmentados": 6000,
    "Linfócitos": 2700,
    "Monócitos": 300
  },
  {
    "Hemograma": 70,
    "Idade": 78,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.04,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 111.84,
    "Hem. Corp. Média": 37.17,
    "C. H. Corp. Média": 33.24,
    "Leucócitos": 4000,
    "Basófilos": 0,
    "Eosinófilos": 240,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 40,
    "Segmentados": 2400,
    "Linfócitos": 1160,
    "Monócitos": 160
  },
  {
    "Hemograma": 71,
    "Idade": 57,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.19,
    "Hemoglobina": 11.8,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 88.31,
    "Hem. Corp. Média": 28.16,
    "C. H. Corp. Média": 31.89,
    "Leucócitos": 5600,
    "Basófilos": 0,
    "Eosinófilos": 112,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 168,
    "Segmentados": 2744,
    "Linfócitos": 2464,
    "Monócitos": 112
  },
  {
    "Hemograma": 72,
    "Idade": 73,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.88,
    "Hemoglobina": 11.1,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 87.63,
    "Hem. Corp. Média": 28.61,
    "C. H. Corp. Média": 32.65,
    "Leucócitos": 3800,
    "Basófilos": 0,
    "Eosinófilos": 38,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 38,
    "Segmentados": 1900,
    "Linfócitos": 1748,
    "Monócitos": 76
  },
  {
    "Hemograma": 73,
    "Idade": 45,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.69,
    "Hemoglobina": 11.1,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 92.14,
    "Hem. Corp. Média": 30.08,
    "C. H. Corp. Média": 32.65,
    "Leucócitos": 6100,
    "Basófilos": 0,
    "Eosinófilos": 183,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 61,
    "Segmentados": 3843,
    "Linfócitos": 1708,
    "Monócitos": 305
  },
  {
    "Hemograma": 74,
    "Idade": 65,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.91,
    "Hemoglobina": 11.6,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 89.51,
    "Hem. Corp. Média": 29.67,
    "C. H. Corp. Média": 33.14,
    "Leucócitos": 4100,
    "Basófilos": 0,
    "Eosinófilos": 205,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 41,
    "Segmentados": 2132,
    "Linfócitos": 1599,
    "Monócitos": 123
  },
  {
    "Hemograma": 75,
    "Idade": 58,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.82,
    "Hemoglobina": 12.2,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 96.86,
    "Hem. Corp. Média": 31.94,
    "C. H. Corp. Média": 32.97,
    "Leucócitos": 4600,
    "Basófilos": 0,
    "Eosinófilos": 276,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 46,
    "Segmentados": 1794,
    "Linfócitos": 2346,
    "Monócitos": 138
  },
  {
    "Hemograma": 76,
    "Idade": 40,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.65,
    "Hemoglobina": 11.9,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 95.89,
    "Hem. Corp. Média": 32.6,
    "C. H. Corp. Média": 34,
    "Leucócitos": 5600,
    "Basófilos": 0,
    "Eosinófilos": 56,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 112,
    "Segmentados": 2856,
    "Linfócitos": 2408,
    "Monócitos": 168
  },
  {
    "Hemograma": 77,
    "Idade": 51,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.95,
    "Hemoglobina": 14.4,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 93.67,
    "Hem. Corp. Média": 36.46,
    "C. H. Corp. Média": 38.92,
    "Leucócitos": 5200,
    "Basófilos": 0,
    "Eosinófilos": 104,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 52,
    "Segmentados": 3120,
    "Linfócitos": 1820,
    "Monócitos": 104
  },
  {
    "Hemograma": 78,
    "Idade": 19,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.25,
    "Hemoglobina": 13.2,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 94.12,
    "Hem. Corp. Média": 31.06,
    "C. H. Corp. Média": 33,
    "Leucócitos": 6500,
    "Basófilos": 0,
    "Eosinófilos": 65,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 65,
    "Segmentados": 3510,
    "Linfócitos": 2665,
    "Monócitos": 195
  },
  {
    "Hemograma": 79,
    "Idade": 52,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.22,
    "Hemoglobina": 14.4,
    "Hematócrito": 0.42,
    "Vol. Corp. Médio": 99.53,
    "Hem. Corp. Média": 34.12,
    "C. H. Corp. Média": 34.29,
    "Leucócitos": 4900,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 49,
    "Segmentados": 2793,
    "Linfócitos": 1960,
    "Monócitos": 98
  },
  {
    "Hemograma": 80,
    "Idade": 66,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.37,
    "Hemoglobina": 14.6,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 98.4,
    "Hem. Corp. Média": 33.41,
    "C. H. Corp. Média": 33.95,
    "Leucócitos": 7200,
    "Basófilos": 0,
    "Eosinófilos": 432,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 72,
    "Segmentados": 3744,
    "Linfócitos": 2664,
    "Monócitos": 288
  },
  {
    "Hemograma": 81,
    "Idade": 17,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.87,
    "Hemoglobina": 11.6,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 87.86,
    "Hem. Corp. Média": 29.97,
    "C. H. Corp. Média": 34.12,
    "Leucócitos": 6100,
    "Basófilos": 0,
    "Eosinófilos": 122,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 61,
    "Segmentados": 2440,
    "Linfócitos": 3233,
    "Monócitos": 244
  },
  {
    "Hemograma": 82,
    "Idade": 51,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.61,
    "Hemoglobina": 12.2,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 99.72,
    "Hem. Corp. Média": 33.8,
    "C. H. Corp. Média": 33.89,
    "Leucócitos": 5000,
    "Basófilos": 0,
    "Eosinófilos": 50,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 50,
    "Segmentados": 2950,
    "Linfócitos": 1800,
    "Monócitos": 150
  },
  {
    "Hemograma": 83,
    "Idade": 28,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.17,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 100.95,
    "Hem. Corp. Média": 34.07,
    "C. H. Corp. Média": 33.75,
    "Leucócitos": 8800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 176,
    "Segmentados": 5632,
    "Linfócitos": 2816,
    "Monócitos": 176
  },
  {
    "Hemograma": 84,
    "Idade": 17,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.17,
    "Hemoglobina": 11.5,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 82.49,
    "Hem. Corp. Média": 27.58,
    "C. H. Corp. Média": 33.43,
    "Leucócitos": 4600,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 46,
    "Segmentados": 2852,
    "Linfócitos": 1610,
    "Monócitos": 92
  },
  {
    "Hemograma": 85,
    "Idade": 6,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.86,
    "Hemoglobina": 12.2,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 93.26,
    "Hem. Corp. Média": 31.61,
    "C. H. Corp. Média": 33.89,
    "Leucócitos": 4200,
    "Basófilos": 0,
    "Eosinófilos": 42,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 84,
    "Segmentados": 1932,
    "Linfócitos": 1974,
    "Monócitos": 168
  },
  {
    "Hemograma": 86,
    "Idade": 63,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.08,
    "Hemoglobina": 12.5,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 90.69,
    "Hem. Corp. Média": 30.64,
    "C. H. Corp. Média": 33.78,
    "Leucócitos": 6700,
    "Basófilos": 0,
    "Eosinófilos": 134,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 67,
    "Segmentados": 2546,
    "Linfócitos": 3819,
    "Monócitos": 134
  },
  {
    "Hemograma": 87,
    "Idade": 50,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.24,
    "Hemoglobina": 13.9,
    "Hematócrito": 0.4,
    "Vol. Corp. Médio": 94.34,
    "Hem. Corp. Média": 32.78,
    "C. H. Corp. Média": 34.75,
    "Leucócitos": 5400,
    "Basófilos": 0,
    "Eosinófilos": 54,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 54,
    "Segmentados": 2430,
    "Linfócitos": 2754,
    "Monócitos": 108
  },
  {
    "Hemograma": 88,
    "Idade": 63,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.75,
    "Hemoglobina": 11.7,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 93.33,
    "Hem. Corp. Média": 31.2,
    "C. H. Corp. Média": 33.43,
    "Leucócitos": 7500,
    "Basófilos": 0,
    "Eosinófilos": 75,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 450,
    "Segmentados": 5175,
    "Linfócitos": 1500,
    "Monócitos": 300
  },
  {
    "Hemograma": 89,
    "Idade": 20,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.07,
    "Hemoglobina": 11.7,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 88.45,
    "Hem. Corp. Média": 28.75,
    "C. H. Corp. Média": 32.5,
    "Leucócitos": 9100,
    "Basófilos": 0,
    "Eosinófilos": 273,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 364,
    "Segmentados": 5187,
    "Linfócitos": 2912,
    "Monócitos": 364
  },
  {
    "Hemograma": 90,
    "Idade": 64,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 2.33,
    "Hemoglobina": 7.8,
    "Hematócrito": 0.25,
    "Vol. Corp. Médio": 107.3,
    "Hem. Corp. Média": 33.48,
    "C. H. Corp. Média": 31.2,
    "Leucócitos": 6000,
    "Basófilos": 0,
    "Eosinófilos": 60,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 360,
    "Segmentados": 3900,
    "Linfócitos": 1440,
    "Monócitos": 240
  },
  {
    "Hemograma": 91,
    "Idade": 48,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.22,
    "Hemoglobina": 10.2,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 78.2,
    "Hem. Corp. Média": 24.17,
    "C. H. Corp. Média": 30.91,
    "Leucócitos": 3900,
    "Basófilos": 0,
    "Eosinófilos": 156,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 39,
    "Segmentados": 1560,
    "Linfócitos": 1950,
    "Monócitos": 195
  },
  {
    "Hemograma": 92,
    "Idade": 28,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 2.77,
    "Hemoglobina": 8.3,
    "Hematócrito": 0.26,
    "Vol. Corp. Médio": 93.86,
    "Hem. Corp. Média": 29.96,
    "C. H. Corp. Média": 31.92,
    "Leucócitos": 7200,
    "Basófilos": 0,
    "Eosinófilos": 216,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 432,
    "Segmentados": 3816,
    "Linfócitos": 2376,
    "Monócitos": 360
  },
  {
    "Hemograma": 93,
    "Idade": 74,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.29,
    "Hemoglobina": 10.9,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 97.26,
    "Hem. Corp. Média": 33.13,
    "C. H. Corp. Média": 34.06,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 204,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 68,
    "Segmentados": 5032,
    "Linfócitos": 1156,
    "Monócitos": 340
  },
  {
    "Hemograma": 94,
    "Idade": 35,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.04,
    "Hemoglobina": 10.5,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 81.68,
    "Hem. Corp. Média": 25.99,
    "C. H. Corp. Média": 31.82,
    "Leucócitos": 8900,
    "Basófilos": 0,
    "Eosinófilos": 89,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 267,
    "Segmentados": 6230,
    "Linfócitos": 1958,
    "Monócitos": 356
  },
  {
    "Hemograma": 95,
    "Idade": 1,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.78,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 87.3,
    "Hem. Corp. Média": 28.6,
    "C. H. Corp. Média": 32.7,
    "Leucócitos": 10800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 216,
    "Segmentados": 3888,
    "Linfócitos": 6480,
    "Monócitos": 216
  },
  {
    "Hemograma": 96,
    "Idade": 52,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4,
    "Hemoglobina": 12,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 90,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 8800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 6864,
    "Linfócitos": 1936,
    "Monócitos": 0
  },
  {
    "Hemograma": 97,
    "Idade": 11,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4,
    "Hemoglobina": 12,
    "Hematócrito": 0.36,
    "Vol. Corp. Médio": 90,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 6500,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 65,
    "Segmentados": 4485,
    "Linfócitos": 1950,
    "Monócitos": 0
  },
  {
    "Hemograma": 98,
    "Idade": 24,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.7,
    "Hemoglobina": 11,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 89.2,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 10900,
    "Basófilos": 0,
    "Eosinófilos": 218,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 7194,
    "Linfócitos": 3488,
    "Monócitos": 0
  },
  {
    "Hemograma": 99,
    "Idade": 42,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.8,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 89.5,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 8500,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 170,
    "Segmentados": 6630,
    "Linfócitos": 1700,
    "Monócitos": 0
  },
  {
    "Hemograma": 100,
    "Idade": 82,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.1,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 90.2,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 7400,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 5402,
    "Linfócitos": 1998,
    "Monócitos": 0
  },
  {
    "Hemograma": 101,
    "Idade": 82,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.2,
    "Hemoglobina": 9.3,
    "Hematócrito": 0.28,
    "Vol. Corp. Médio": 87.5,
    "Hem. Corp. Média": 29.1,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 2600,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 1638,
    "Linfócitos": 962,
    "Monócitos": 0
  },
  {
    "Hemograma": 102,
    "Idade": 72,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.3,
    "Hemoglobina": 13,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 90.7,
    "Hem. Corp. Média": 30.2,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 5400,
    "Basófilos": 0,
    "Eosinófilos": 108,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 108,
    "Segmentados": 3132,
    "Linfócitos": 1890,
    "Monócitos": 162
  },
  {
    "Hemograma": 103,
    "Idade": 61,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.2,
    "Hemoglobina": 12.6,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 90.5,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 5700,
    "Basófilos": 0,
    "Eosinófilos": 57,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 114,
    "Segmentados": 3990,
    "Linfócitos": 1425,
    "Monócitos": 114
  },
  {
    "Hemograma": 104,
    "Idade": 33,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 5.01,
    "Hemoglobina": 15,
    "Hematócrito": 0.45,
    "Vol. Corp. Médio": 89.8,
    "Hem. Corp. Média": 29.9,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 8400,
    "Basófilos": 0,
    "Eosinófilos": 168,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 252,
    "Segmentados": 4704,
    "Linfócitos": 3108,
    "Monócitos": 168
  },
  {
    "Hemograma": 105,
    "Idade": 20,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.1,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 90.2,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 4000,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 40,
    "Segmentados": 2400,
    "Linfócitos": 1560,
    "Monócitos": 0
  },
  {
    "Hemograma": 106,
    "Idade": 3,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.9,
    "Hemoglobina": 11.7,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 89.7,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.4,
    "Leucócitos": 5800,
    "Basófilos": 0,
    "Eosinófilos": 406,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 116,
    "Segmentados": 2262,
    "Linfócitos": 2900,
    "Monócitos": 116
  },
  {
    "Hemograma": 107,
    "Idade": 9,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.7,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 89.2,
    "Hem. Corp. Média": 29.2,
    "C. H. Corp. Média": 32.7,
    "Leucócitos": 12300,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 1107,
    "Segmentados": 10209,
    "Linfócitos": 984,
    "Monócitos": 0
  },
  {
    "Hemograma": 108,
    "Idade": 71,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.8,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 89.5,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 10400,
    "Basófilos": 0,
    "Eosinófilos": 312,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 208,
    "Segmentados": 6552,
    "Linfócitos": 3120,
    "Monócitos": 208
  },
  {
    "Hemograma": 109,
    "Idade": 1,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.7,
    "Hemoglobina": 10.3,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 83.8,
    "Hem. Corp. Média": 27.8,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 9800,
    "Basófilos": 0,
    "Eosinófilos": 980,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 3724,
    "Linfócitos": 4900,
    "Monócitos": 196
  },
  {
    "Hemograma": 110,
    "Idade": 84,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.1,
    "Hemoglobina": 9,
    "Hematócrito": 0.27,
    "Vol. Corp. Médio": 87.1,
    "Hem. Corp. Média": 29,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 6600,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 0,
    "Segmentados": 4950,
    "Linfócitos": 1650,
    "Monócitos": 0
  },
  {
    "Hemograma": 111,
    "Idade": 86,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.9,
    "Hemoglobina": 11.6,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 89.7,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.1,
    "Leucócitos": 4400,
    "Basófilos": 0,
    "Eosinófilos": 44,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 88,
    "Segmentados": 2244,
    "Linfócitos": 2024,
    "Monócitos": 0
  },
  {
    "Hemograma": 112,
    "Idade": 1,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.68,
    "Hemoglobina": 10.4,
    "Hematócrito": 0.32,
    "Vol. Corp. Médio": 87,
    "Hem. Corp. Média": 28.3,
    "C. H. Corp. Média": 32.5,
    "Leucócitos": 8700,
    "Basófilos": 0,
    "Eosinófilos": 174,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 174,
    "Segmentados": 2610,
    "Linfócitos": 5394,
    "Monócitos": 348
  },
  {
    "Hemograma": 113,
    "Idade": 11,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.2,
    "Hemoglobina": 12.4,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 90.5,
    "Hem. Corp. Média": 29.5,
    "C. H. Corp. Média": 32.6,
    "Leucócitos": 6700,
    "Basófilos": 0,
    "Eosinófilos": 67,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 134,
    "Segmentados": 4355,
    "Linfócitos": 2010,
    "Monócitos": 134
  },
  {
    "Hemograma": 114,
    "Idade": 1,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.72,
    "Hemoglobina": 10.8,
    "Hematócrito": 0.33,
    "Vol. Corp. Médio": 88.7,
    "Hem. Corp. Média": 29,
    "C. H. Corp. Média": 32.7,
    "Leucócitos": 13200,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 1056,
    "Segmentados": 6600,
    "Linfócitos": 5544,
    "Monócitos": 0
  },
  {
    "Hemograma": 115,
    "Idade": 4,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.3,
    "Hemoglobina": 13,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 90.7,
    "Hem. Corp. Média": 30.2,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 408,
    "Segmentados": 2652,
    "Linfócitos": 3468,
    "Monócitos": 272
  },
  {
    "Hemograma": 116,
    "Idade": 5,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 3.9,
    "Hemoglobina": 11.6,
    "Hematócrito": 0.35,
    "Vol. Corp. Médio": 89.7,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.1,
    "Leucócitos": 12000,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 480,
    "Segmentados": 9480,
    "Linfócitos": 2040,
    "Monócitos": 0
  },
  {
    "Hemograma": 117,
    "Idade": 78,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.7,
    "Hemoglobina": 14.2,
    "Hematócrito": 0.43,
    "Vol. Corp. Médio": 91.5,
    "Hem. Corp. Média": 30.2,
    "C. H. Corp. Média": 33,
    "Leucócitos": 10100,
    "Basófilos": 0,
    "Eosinófilos": 101,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 202,
    "Segmentados": 6767,
    "Linfócitos": 2828,
    "Monócitos": 202
  },
  {
    "Hemograma": 118,
    "Idade": 12,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.2,
    "Hemoglobina": 12.6,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 90.5,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 5100,
    "Basófilos": 0,
    "Eosinófilos": 204,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 102,
    "Segmentados": 2601,
    "Linfócitos": 2040,
    "Monócitos": 153
  },
  {
    "Hemograma": 119,
    "Idade": 16,
    "sexo 0 ou 1": 1,
    "Sexo": "masculino",
    "Hemácias": 4.3,
    "Hemoglobina": 13,
    "Hematócrito": 0.39,
    "Vol. Corp. Médio": 90.7,
    "Hem. Corp. Média": 30.2,
    "C. H. Corp. Média": 33.3,
    "Leucócitos": 5800,
    "Basófilos": 0,
    "Eosinófilos": 58,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 116,
    "Segmentados": 3712,
    "Linfócitos": 1740,
    "Monócitos": 174
  },
  {
    "Hemograma": 120,
    "Idade": 75,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.2,
    "Hemoglobina": 12.6,
    "Hematócrito": 0.38,
    "Vol. Corp. Médio": 90.5,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 5700,
    "Basófilos": 0,
    "Eosinófilos": 285,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 114,
    "Segmentados": 3420,
    "Linfócitos": 1767,
    "Monócitos": 114
  },
  {
    "Hemograma": 121,
    "Idade": 28,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 4.1,
    "Hemoglobina": 12.3,
    "Hematócrito": 0.37,
    "Vol. Corp. Médio": 90.2,
    "Hem. Corp. Média": 30,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 6800,
    "Basófilos": 0,
    "Eosinófilos": 272,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 136,
    "Segmentados": 3672,
    "Linfócitos": 2584,
    "Monócitos": 136
  },
  {
    "Hemograma": 122,
    "Idade": 23,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.58,
    "Hemoglobina": 10.7,
    "Hematócrito": 0.31,
    "Vol. Corp. Médio": 86.6,
    "Hem. Corp. Média": 29.9,
    "C. H. Corp. Média": 34.5,
    "Leucócitos": 7100,
    "Basófilos": 0,
    "Eosinófilos": 71,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 142,
    "Segmentados": 3550,
    "Linfócitos": 3053,
    "Monócitos": 284
  },
  {
    "Hemograma": 123,
    "Idade": 89,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.24,
    "Hemoglobina": 9,
    "Hematócrito": 0.28,
    "Vol. Corp. Médio": 86.4,
    "Hem. Corp. Média": 27.8,
    "C. H. Corp. Média": 32.1,
    "Leucócitos": 9600,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 384,
    "Segmentados": 7200,
    "Linfócitos": 2016,
    "Monócitos": 0
  },
  {
    "Hemograma": 124,
    "Idade": 96,
    "sexo 0 ou 1": 0,
    "Sexo": "feminino",
    "Hemácias": 3.8,
    "Hemoglobina": 11.3,
    "Hematócrito": 0.34,
    "Vol. Corp. Médio": 89.5,
    "Hem. Corp. Média": 29.7,
    "C. H. Corp. Média": 33.2,
    "Leucócitos": 6300,
    "Basófilos": 0,
    "Eosinófilos": 0,
    "Mieloócitos": 0,
    "Jovens": 0,
    "Bastões": 315,
    "Segmentados": 4662,
    "Linfócitos": 1323,
    "Monócitos": 0
  }
]